module.exports = __webpack_public_path__ + "img/logo1.b67665f8.png";